// istanbul ignore file
/* eslint-disable */
// ignore lint and test rules since this is a slightly altered ARIA SDK and will be replaced with the current third party version by Work Item 348115

import { KeyValuePair } from "./microsoft.bond";

export class Set<T> {
  Add(t: T): void {
    var i = 0;
    for (; i < this._buffer.length; ++i) {
      if (this._buffer[i] == t) {
        break;
      }
    }
    if (i == this._buffer.length) {
      this._buffer.push(t);
    }
  }

  Count(): number {
    return this._buffer.length;
  }

  GetBuffer(): T[] {
    return this._buffer;
  }

  private _buffer: T[] = [];
}

// Modified bond code to add AddorReplace and Remove for Map
//TODO(abpanwar): Contact the bond team to add this to their library.
export class Map<TKey, TValue> {
  Add(key: TKey, value: TValue) {
    if (this._getIndex(key) == -1) {
      this._buffer.push({ Key: key, Value: value });
    }
  }

  AddOrReplace(key: TKey, value: TValue) {
    var i = this._getIndex(key);
    if (i >= 0) {
      this._buffer[i] = { Key: key, Value: value };
    } else {
      this._buffer.push({ Key: key, Value: value });
    }
  }

  Remove(key: TKey) {
    var i = this._getIndex(key);
    if (i >= 0) {
      this._buffer.splice(i, 1);
    }
  }

  Count(): number {
    return this._buffer.length;
  }

  GetBuffer(): KeyValuePair<TKey, TValue>[] {
    return this._buffer;
  }

  ContainsKey(key: TKey): boolean {
    if (this._getIndex(key) >= 0) {
      return true;
    }
    return false;
  }

  Get(key: TKey): TValue {
    var i = this._getIndex(key);
    if (i >= 0) {
      return this._buffer[i].Value!!!;
    }
    return null!!!;
  }

  private _getIndex(key: TKey): number {
    var i = 0;
    var index = -1;
    for (; i < this._buffer.length; ++i) {
      if (this._buffer[i].Key == key) {
        index = i;
        break;
      }
    }
    return index;
  }

  private _buffer: KeyValuePair<TKey, TValue>[] = [];
}
